import { Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import React from "react";
import { CTM_Colors } from "../Helper";

interface CTM_Grid_Props {
    displayName: string;
    value: string | number;
    defaultValue?: string;
    size?: { xs?: number, sm?: number, md?: number };
}

const CTM_Grid_Element: React.FC<CTM_Grid_Props> = ({ displayName, value, defaultValue, size }) => {
    const sizeGrid = { xs: size?.xs ?? 2, sm: size?.sm ?? 4, md: size?.md ?? 4 };
    return (
        <Grid size={sizeGrid}>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: CTM_Colors.ctm_green }}>
                {displayName}
            </Typography>
            <Typography>{value || (!!defaultValue ? defaultValue : '-')}</Typography>
        </Grid>
    )
}

export default CTM_Grid_Element;